import React from 'react';
import { Chip, Paper, Stack, Typography, Box } from '@mui/material';

export type LaneSummaryItem = {
  label: string;
  value: string;
};

export type LaneSummarySignal = {
  label: string;
  color?: 'default' | 'info' | 'success' | 'warning' | 'error';
};

type LaneSummaryStripProps = {
  items: LaneSummaryItem[];
  signals?: LaneSummarySignal[];
  children?: React.ReactNode;
};

export function LaneSummaryStrip({ items, signals = [], children }: LaneSummaryStripProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={1.5}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: `repeat(${Math.max(items.length, 1)}, minmax(0, 1fr))` },
            gap: 2,
          }}
        >
          {items.map((item) => (
            <Box key={item.label}>
              <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                {item.label}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 700 }}>
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>

        {children}

        {signals.length > 0 ? (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {signals.map((signal) => (
              <Chip
                key={signal.label}
                size="small"
                color={signal.color || 'default'}
                variant="outlined"
                label={signal.label}
              />
            ))}
          </Stack>
        ) : null}
      </Stack>
    </Paper>
  );
}
